import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid rgba(228, 215, 205, 0.5);
  background: rgba(249, 242, 236, 0.5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 9px 18px;
  
  color: rgba(89, 78, 71, 0.5);
`
export const Dates = styled.div`
  font-size: 14px;
  color: rgba(137, 121, 110, 0.5);
`

export const ActionBtns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const DDContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const DDButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  font-size: 12px;
  color: rgba(57, 29, 10, 1);
  background: none;
  border: none;
  border-radius: 4px;
  padding: 8px;
  text-align: left;
  
  &:hover {
    cursor: pointer;
    background: rgba(240, 229, 222, 1);
  }
`

export const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: pointer;

  color: rgba(137, 121, 110, 1);
  background: none;
  border: none;
`
export const ExtraActions = styled.div`
  display: flex;
  font-size: 14px;
  color: rgba(137, 121, 110, 0.5);
`

export const IconWrapper = styled.div<{ isOpen?: boolean; }>`
  transform: ${props => props.isOpen ? 'rotate(0deg)' : 'rotate(-90deg)'};
  transition: all 0.25s ease-in;
`

export const Title = styled.div`
  padding: 4px 18px;
  font-size: 24px;
  line-height: 120%;
  font-family: 'Cormorant', sans-serif;
  font-weight: 600;
  color: rgba(57, 29, 10, 0.5);
`

export const ContentWrapper = styled.div`
  overflow: hidden;
  transition: all 0.25s ease-in;
`

export const Content = styled.div<{ isOpen?: boolean; }>`
  padding: 18px;
`
